import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import TimeOutputLayoutAddForm from 'components/organismos/master/attend/TimeOutputLayout/TimeOutputLayoutAddForm';
import { useParams } from 'react-router-dom';

const TimeOutputLayoutAddPage: React.FC = () => {
  const {
    layoutId,
  } = useParams();

  return (
    <SidebarTemplate
      pageTitle={layoutId ? '勤怠出力レイアウト編集' : '新規勤怠出力レイアウト作成'}
    >
      <TimeOutputLayoutAddForm />
    </SidebarTemplate>
  );
};

export default TimeOutputLayoutAddPage;
